import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import { objectsToArray, sortArrayBy } from 'functions/utilities'

const sortSections = (campaignQuoteSections) => {
  const array = objectsToArray(campaignQuoteSections)
  return sortArrayBy(array, 'asc', 'sort')
}

class QuoteWrapper extends React.Component {
  render(){
    const { campaignQuoteSections, render } = this.props

    return render({
      quoteSections: sortSections(campaignQuoteSections),
    })
  }
}

QuoteWrapper.propTypes = {
  campaignQuoteSections: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { campaignQuote } = props

  return {
    campaignQuoteSections: filteredObjectsSelector(
      state,
      'campaignQuoteSections',
      'campaign_quote_id',
      campaignQuote.id,
    ),
  }
}

export default connect(mapStateToProps)(QuoteWrapper)
